<template>
  <div>
    <v-sheet max-width="380" class="mx-auto" color="transparent">
      <v-form
          @submit.prevent="!validForm ? null : submit()"
          ref="sendOtpform"
          class="my-10"
      >
        <v-text-field
            @input="validate"
            @blur="validate"
            prepend-inner-icon="mdi-account"
            v-model="userLogin"
            label="Usuario"
            :rules="[ requiredRule ]"
            solo
            flat
        />
        <v-text-field
            @input="validate"
            prepend-inner-icon="email"
            v-model="email"
            label="Email"
            :rules="[ requiredRule, validEmail, limitTo100 ]"
            counter="100"
            solo
            flat
        />

        <v-btn block type="submit" :disabled="!validForm"
        >{{ $t("Global.ForgotPassword.sendText") }}</v-btn
        >
      </v-form>
    </v-sheet>
    <v-snackbar
        v-model="snackbar"
        fixed
        right
        :timeout="snackbarTimeout"
        :color="snackbarColor"
        class="mt-6"
    >
      <span>{{ snackbarMessage }}</span>
      <v-icon class="ml-2" dark>{{ snackbarIcon }}</v-icon>
      <template v-slot:action="{ attrs }">
        <v-btn
            color="white"
            text
            v-bind="attrs"
            @click="snackbar = false"
        >
          {{ $t("Global.ConfirmDialog.buttonTextClose") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import passwordRecoveryApi from "@/mixins/Services/PasswordRecoveryApi";
import snackBar from "@/mixins/snackBarMixin";
import snackbarError from "@/mixins/snackbarErrorControl";
import loader from "@/mixins/Loader";
import utils from "@/mixins/Utils";

export default {
  mixins: [passwordRecoveryApi,snackBar,snackbarError, loader, utils],
  data() {
    return {
      validForm: false,
      errors: null,
      userLogin: null,
      email: null,
      requiredRule: v => !!v || this.$t('Global.FormRules.requiredField'),
      validEmail: v => v == null || v === "" || !!v.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/) ? true : this.$t('Global.FormRules.invalidFormat'),
      limitTo100: v => v == null || v === "" || v.length <= 100 ? true : this.$t('Global.FormRules.characterLimit')
    };
  },
  methods: {
    validate() {
      this.validForm = this.$refs.sendOtpform.validate()
    },
    async submit() {
      try {
        const data = {
          userLogin: this.userLogin,
          email: this.email
        }
        this.setLoader(true)
        await this.recoverPassword(data)
        this.setLoader(false)
        this.resetData()
        this.$emit("next");
      } catch (e) {
        this.setLoader(false)
        console.error('[SEND_OPT][submit] ERROR:', e)
        if(this.isErrorText(e)){
          const textError = this.getErrorText(e);
          this.launchSnackbar(this.$t(`Global.Error.c${textError}`), 'error', "2000", 'mdi-alert-octagon')
          this.resetData()
        }
      }
    },
    resetData(){
      this.userLogin = null
      this.email = null
    }
  }
};
</script>
